import { setCookie } from './cookie';

export default (name) => {
  const current = localStorage.getItem(name);

  setCookie(name, current, {
    expires: new Date(Date.now() + 86400e3 * 365),
    path: '/',
  });
};
